import React, { useState } from "react";
import { XIcon } from "@heroicons/react/solid";

const TSIcon = require("../assets/icons/TSIcon.png");
const JSIcon = require("../assets/icons/JSIcon.png");

interface Props {
  activeTab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
}

const tabs = [
  { id: "home", name: "Home.tsx", icon: JSIcon, closable: false },
  { id: "about", name: "About.tsx", icon: TSIcon, closable: true },
  { id: "resume", name: "Resume.tsx", icon: TSIcon, closable: true },
  { id: "projects", name: "Projects.tsx", icon: TSIcon, closable: true },
  { id: "contact", name: "Contact.tsx", icon: TSIcon, closable: true },
];

const NavBar: React.FC<Props> = ({ activeTab, setActiveTab }) => {
  const [closedTabs, setClosedTabs] = useState<string[]>([]);

  const handleCloseTab = (e: React.MouseEvent, tabId: string) => {
    e.stopPropagation();
    setClosedTabs((prev) => [...prev, tabId]);
    if (activeTab === tabId) {
      setActiveTab("home");
    }
  };

  return (
    <div className="flex h-full bg-[#252526]">
      {/* Tabs Container */}
      <div className="flex items-end">
        {tabs.map((tab) => {
          if (closedTabs.includes(tab.id)) return null;

          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`group relative flex items-center h-[35px] px-3 text-sm transition-colors ${isActive
                  ? "bg-[#1e1e1e] text-white"
                  : "bg-[#2d2d2d] text-[#969696] hover:bg-[#323232]"
                }`}
              style={{
                borderTop: isActive ? "1px solid #007acc" : "1px solid transparent",
                borderRight: "1px solid #1e1e1e",
              }}
            >
              <img src={tab.icon} alt="" className="w-4 h-4 mr-2" />
              <span className="whitespace-nowrap">{tab.name}</span>
              {tab.closable && (
                <XIcon
                  className={`w-4 h-4 ml-2 rounded hover:bg-[#525252] ${isActive ? "opacity-100" : "opacity-0 group-hover:opacity-100"
                    }`}
                  onClick={(e) => handleCloseTab(e, tab.id)}
                />
              )}
              {!tab.closable && <div className="w-4 ml-2" />}
            </button>
          );
        })}
      </div>

      {/* Right side spacer - fills remaining space with tab bar background */}
      <div className="flex-1 bg-[#252526]" />
    </div>
  );
};

export default NavBar;
